<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Notable Diagnostic Tests Results: Biochemical Tests
        </h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Biochemical test results<sup>1</sup></h3>
            <ul class="list-disc pl-4  font-light">
                <li>
                    The blood gas analysis showed metabolic acidosis
                </li>
            </ul>

            <p class=" mt-3 font-light italic">Urinalysis</p>
            <ul class="list-disc pl-4  font-light">
                <li>
                    Urine examination showed proteinuria 1+, 2–3 red cells/high-power field,  10–12 leukocytes/high-power field, granular casts, and oxalate crystals
                </li>
                <li>
                    The spot urine protein to creatinine ratio was 0.6
                </li>
            </ul>
        </div>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">
                Notable Biochemical Tests Results
            </h3>

            <table class="w-full table-fixed border-collapse border-solid border-2 border-darkergrey break-words">
                <thead class="text-center text-white text-base md:text-lg">
                    <tr class="bg-lightblue">
                        <th class="p-3 border-solid border-2 border-darkergrey">&nbsp;</th>
                        <th class="p-3 border-solid border-2 border-darkergrey">Result</th>
                        <th class="p-3 border-solid border-2 border-darkergrey">Reference value</th>
                    </tr>
                </thead>

                <tbody class="text-center text-darkerblue text-sm md:text-base">
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Urea, mg/dL</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">190<sup>1</sup></td>
                        <td class="p-3 border-solid border-2 border-darkergrey">5-20<sup>2</sup></td>
                    </tr>
                    <tr class="bg-white">
                        <td class="p-3 border-solid border-2 border-darkergrey">Creatinine, mg/dL</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">15.5<sup>1</sup></td>
                        <td class="p-3 border-solid border-2 border-darkergrey">0.5 to 1.1<sup>*2</sup></td>
                    </tr>
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">24-hour urinary oxalate excretion, mg</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">210<sup>1</sup></td>
                        <td class="p-3 border-solid border-2 border-darkergrey">7.0-44.0<sup>1</sup></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
